import { BlockType } from '../../types/index.js';
import { CardHeaderBlock as Component } from './Block.js';
export const RegisteredCardHeaderBlock = (_intl) => ({
    recommendedName: 'Card.Header',
    Component,
    config: {
        type: BlockType.BuildingBlock,
        defaultProps: {
            size: 'sm',
        },
    },
});
//# sourceMappingURL=registered.js.map